module.exports = __webpack_public_path__ + "img/newsImg3-18.6070e7e3.png";